import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

export const actionsToIgnore = [
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  'alertHandler/openAlert',
  'alertHandler/closeAlert',
];

export const stateSyncWhiteList = [
  'userLogin/pending',
  'userLogin/fulfilled',
  'userLogin/rejected',

  'setUserData/pending',
  'setUserData/fulfilled',
  'setUserData/rejected',

  'USER_LOGOUT',
  'logout/pending',
  'logout/fulfilled',
  'logout/rejected',

  'user/clearUser',
];
